import React from "react";
import config from "../config";

const ServiceNowLink = () => {
  return (
    <a
      className="ui button primary mini servicenow-link"
      href={config.services.servicenowURL}
      target="_blank"
    >
      Open ServiceNow
    </a>
  );
};

export default ServiceNowLink;
